import { render } from "./clipboard.vue?vue&type=template&id=76e2cba6&scoped=true"
import script from "./clipboard.vue?vue&type=script&lang=js"
export * from "./clipboard.vue?vue&type=script&lang=js"

import "./clipboard.vue?vue&type=style&index=0&id=76e2cba6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e2cba6"]])

export default __exports__